var _style, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrows9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.1 93.9",
    style: {
      enableBackground: "new 0 0 228.1 93.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B3B3B3;}\r\n\t.st1{fill:#C2000B;}\r\n\t.st2{fill:#545051;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#991014;}\r\n\t.st5{opacity:0.25;}\r\n\t.st6{fill:url(#SVGID_1_);}\r\n\t.st7{fill:url(#SVGID_2_);}\r\n\t.st8{fill:url(#SVGID_3_);}\r\n\t.st9{fill:url(#SVGID_4_);}\r\n\t.st10{fill:url(#SVGID_5_);}\r\n\t.st11{fill:url(#SVGID_6_);}\r\n\t.st12{fill:url(#SVGID_7_);}\r\n\t.st13{fill:url(#SVGID_8_);}\r\n\t.st14{fill:url(#SVGID_9_);}\r\n\t.st15{fill:url(#SVGID_10_);}\r\n\t.st16{fill:url(#SVGID_11_);}\r\n\t.st17{fill:url(#SVGID_12_);}\r\n\t.st18{fill:url(#SVGID_13_);}\r\n\t.st19{fill:url(#SVGID_14_);}\r\n\t.st20{fill:#666666;}\r\n\t.st21{fill:#31977E;}\r\n\t.st22{fill:url(#SVGID_15_);}\r\n\t.st23{fill:url(#SVGID_16_);}\r\n\t.st24{fill:url(#SVGID_17_);}\r\n\t.st25{fill:url(#SVGID_18_);}\r\n\t.st26{fill:#199DBF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.6885,
    y1: 23.3018,
    x2: 228.1075,
    y2: 23.3018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1944,
    style: {
      stopColor: "#F9CB37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7123,
    style: {
      stopColor: "#F38430"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA1C24"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "98.7,31.1 129.7,0.1 228.1,0 228.1,31.6 129.2,31.6 114.2,46.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 67.9915,
    x2: 95.5956,
    y2: 67.9915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33A8C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08271141,
    style: {
      stopColor: "#3DAABC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2258,
    style: {
      stopColor: "#59AFAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4121,
    style: {
      stopColor: "#86B792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6319,
    style: {
      stopColor: "#C3C265"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8048,
    style: {
      stopColor: "#F9CB37"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "80.1,49.7 74.9,54.9 34.6,54.9 34.6,43.2 0,66.1 35.3,92.8 35.3,83.1 77.7,83.1 95.6,65.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2808,
    y1: 47.5955,
    x2: 228.1075,
    y2: 47.5955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33A8C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4274,
    style: {
      stopColor: "#F9CB37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7123,
    style: {
      stopColor: "#F38430"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA1C24"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "66.1,1.5 120.6,55.9 193.5,55.9 193.5,44.2 228.1,67.2 192.8,93.9 192.8,84.2 117.8,84.2 66.5,32.9  0.3,32.9 0.3,1.3  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows9);
export default __webpack_public_path__ + "static/media/arrows9.7d3548293c92afa69ca2ff90c8297208.svg";
export { ForwardRef as ReactComponent };